import { useRouter } from "next/dist/client/router";
import { useContext, useRef, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import HeadPage from "../../../components/HeadPage/HeadPage";
import Input from "../../../components/Input/Input";
import Checkbox from "../../../components/Checkbox/Checkbox";
import QRCode from "../../../components/QRCode/QRCode";
import { ApplicationContext } from "../../../context/ApplicationContext";
import { fetchData } from "../../../fetcher";
import TheMallOutletLayout from "../../../layouts/TheMallOutletLayout/TheMallOutletLayout";
import styles from "../../../styles/pages/form.module.scss";
import Swal from "sweetalert2";
import ReactDOMServer from "react-dom/server";
import CloseIcon from "../../../public/assets/icons/closeIcon.svg";
import ScrollDown from "../../../components/ScrollDown/ScrollDown";
import { removeCookies, checkCookies } from "cookies-next";
import { countryList } from "../../../countries";

const Register = ({ menuItems, dataContent, properties }) => {
  const { setShowLoader } = useContext(ApplicationContext);
  const { marketing } = useContext(ApplicationContext);
  const router = useRouter();
  const { registerData } = useContext(ApplicationContext);
  const scrollToRef = useRef(null);
  const refMail = useRef(null);
  const refPw = useRef(null);
  const refBarcode = useRef(null);
  const [emailCheck, setEmailCheck] = useState();
  const [pwCheck, setPwCheck] = useState();
  const [barcodeCheck, setBarcodeCheck] = useState();
  const [loyalty, setLoyalty] = useState(false);
  const [marketingFlag, setMarketingFlag] = useState(false);
  const [app, setApp] = useState(false);
  const [change, setChange] = useState(false);
  const [profiling, setProfiling] = useState('IT')
  const [loyalty_check, setLoyalty_check] = useState(false)
  const [marketing_check, setMarketing_check] = useState(false)
  const [profiling_check, setProfiling_check] = useState(false)
  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
  } = useForm();

  useEffect(() => {
    if (router.asPath.includes("?app=true")) {
      setApp(true);
    }
  }, []);

  const onSubmit = async (event) => {
    //let date = event.date_of_birth.toLocaleDateString('it-IT').split("/");
    let date = '';
    if(event.date_of_birth) {
      //date = event.date_of_birth?.toLocaleDateString('it-IT').split("/");
      date = event.date_of_birth.split("/");
      if (date?.[1].length == 1) {
        date[1] = "0" + date[1];
      }
      if (date?.[0].length == 1) {
        date[0] = "0" + date[0];
      }
      date = date?.reverse().join("-");
  
    
      if (getAge(date) < 18) {
        Swal.fire({
          title: properties.ERROR_AGE,
          showCloseButton: true,
          showCancelButton: false,
          showConfirmButton: false,
          closeButtonHtml: ReactDOMServer.renderToString(<CloseIcon />),
        });
        return;
      }
    }

    if(specialquery == null || specialquery == undefined || specialquery == '') {
      const _sp = new URLSearchParams(location.search);
      const _paramRedir = _sp.get('redir');
      if(_paramRedir && _paramRedir !== '' && _paramRedir.includes('redeem')) {
        specialquery = 'totemgame';
      }
    }

    //console.log('special query', specialquery);
    let postBody = {
      title: registerData.title.value,
      first_name: event.first_name,
      last_name: event.last_name,
      country: registerData.country,
      email: event.email,
      phone_country_code: event.phone_country_code?.replace(/^\+/, ''),
      phone_number: event.phone_number?.replace(/\D/g, ''),
      password: event.password,
      date_of_birth: date,
      postcode: event.postcode,
      loyalty: event.loyalty,
      profiling_agreement: event.profiling_agreement,
      marketing_agreement: event.marketing_agreement,
      preferred_location_group: process.env.NEXT_PUBLIC_MALL_LOCATION_ID
        ? Number(process.env.NEXT_PUBLIC_MALL_LOCATION_ID)
        : null,
      country_site: router.query.locale,
      barcode: event.barcode,
      specialtrack: specialquery,
    };

    if(specialquery && specialquery.endsWith('.json')) {
      delete postBody.country;
      delete postBody.date_of_birth;
      delete postBody.postcode;
      delete postBody.profiling_agreement;
      delete postBody.marketing_agreement;
      delete postBody.phone_country_code;
      delete postBody.phone_number;

      if(router.query.locale == 'fr') {
        if(postBody.title == 'Mr') postBody.title = 'Monsieur';
        else if(postBody.title == 'Miss') postBody.title = 'Madamoiselle';
        else if(postBody.title == 'Mrs') postBody.title = 'Madam';
      }
    }


    setShowLoader(true);
    const res = await fetch(
      `${process.env.NEXT_PUBLIC_FE_COMMON}/registration`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(postBody),
      }
    );

    const resjs = await res?.json();
    setShowLoader(false);

    if (checkCookies("myarea")) {
      removeCookies("myarea");
    }

    const sp = new URLSearchParams(location.search);
    const paramRedir = sp.get('redir');
    let finalRedir = properties.REDIRECT_LOGIN;

    if(paramRedir && paramRedir !== '') {
      finalRedir = paramRedir;
    }

    if (resjs?.message) {
      Swal.fire({
        title: properties[resjs.message],
        showCloseButton: true,
        showCancelButton: false,
        showConfirmButton: false,
        closeButtonHtml: ReactDOMServer.renderToString(
          resjs.result ? (
            <a href={finalRedir}>
              <CloseIcon />
            </a>
          ) : (
            <CloseIcon />
          )
        ),
      });
    }

  };

  const getAge = (dateString) => {
    var today = new Date();
    var birthDate = new Date(dateString);
    var age = today.getFullYear() - birthDate.getFullYear();
    var m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  };

  const onError = (errors, e) => {
    console.log(e);
  };

  useEffect(() => {
    const handleClickOutside = async (event) => {
      if (
        change &&
        ((emailCheck &&
          emailCheck.includes("@") &&
          emailCheck.includes(".") &&
          emailCheck.length > 5 &&
          pwCheck &&
          refMail.current &&
          !refMail.current.contains(event.target) &&
          refPw.current &&
          !refPw.current.contains(event.target)) ||
          (refBarcode.current && !refBarcode.current.contains(event.target)))
      ) {
        const res = await fetch(
          `${process.env.NEXT_PUBLIC_FE_COMMON}/check_flag`,
          {
            method: "POST",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              email: emailCheck,
              password: pwCheck,
              barcode: barcodeCheck,
            }),
          }
        );

        const resjs = await res.json();
        setLoyalty(resjs?.loyalty);
        setMarketingFlag(resjs?.marketing);
        setChange(false);
      }
    };
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, [emailCheck, pwCheck, change, barcodeCheck]);

  const formItem = dataContent.layouts.form.data.items;
  
  // Special track dalla query string
  let specialquery = '';
  var route = useRouter();
  specialquery = route.query["s"];
  
  return (
    <TheMallOutletLayout menuItems={menuItems} app={app}>
      {!app && <HeadPage {...dataContent?.layouts.head.data.blocks} />}
      <div className="transparent" ref={scrollToRef}>
        <div className={styles.registercontainer}>
          <div className={styles.info}>
            <div className={styles.mainTitle}>{dataContent.layouts.form.data.title}</div>
            {/*
            <div
              ref={refBarcode}
              onChange={(e) => {
                setBarcodeCheck(e.target.value);
                setChange(true);
              }}
            >
              <QRCode
                label={properties.QR_CODE_TEXT}
                label2={properties.QR_CODE_TEXT_2}
                click={properties.QR_CODE_LINK}
                QRText={properties.QR_CODE_INFO}
                placeholder={properties.SERIAL_NUMBER_PLACEHOLDER}
                name="barcode"
                inputProps={{
                  ...register(`barcode`),
                }}
              />
            </div>
             */}
          </div>

          <div className={styles.formContainer} style={{ paddingTop: "3rem" }}>
            {dataContent &&
              dataContent.layouts.form.data &&
              dataContent.layouts.form.data.items && (
                <form
                  onSubmit={handleSubmit(onSubmit, onError)}
                  className={styles.register}
                  autoComplete="off"
                >
                  {formItem[0] && (
                    <div style={{ width: "100%", margin: "1rem 0" }}>
                      <Input
                        register
                        name={formItem[0]?.field?.name}
                        placeholder={formItem[0]?.field?.placeholder}
                        type={formItem[0]?.field?.type}
                        errorCheck={errors[formItem[0]?.field?.name]}
                        error={formItem[0]?.field?.error}
                        values={formItem[0]?.field?.values}
                        inputProps={{
                          ...register(`${formItem[0]?.field?.name}`, {
                            required: formItem[0]?.field?.error ? true : false,
                          }),
                        }}
                      />
                    </div>
                  )}
                  <div className={`${styles.flexBox} ${styles.name}`}>
                    <div className={styles.inputContainer}>
                      {formItem[1] && (
                        <Input
                          name={formItem[1]?.field?.name}
                          placeholder={formItem[1]?.field?.placeholder}
                          type={formItem[1]?.field?.type}
                          errorCheck={errors[formItem[1]?.field?.name]}
                          error={formItem[1]?.field?.error}
                          inputProps={{
                            ...register(`${formItem[1]?.field?.name}`, {
                              required: formItem[1]?.field?.error
                                ? true
                                : false,
                              pattern: /[a-zA-ZÀ-ž]{1}[\sa-zA-ZÀ-ž\-']{1,500}/,
                            }),
                          }}
                        />
                      )}
                    </div>
                    <div className={styles.inputContainer}>
                      {formItem[2] && (
                        <Input
                          name={formItem[2]?.field?.name}
                          placeholder={formItem[2]?.field?.placeholder}
                          type={formItem[2]?.field?.type}
                          errorCheck={errors[formItem[2]?.field?.name]}
                          error={formItem[2]?.field?.error}
                          inputProps={{
                            ...register(`${formItem[2]?.field?.name}`, {
                              required: formItem[2]?.field?.error
                                ? true
                                : false,
                              pattern: /[a-zA-ZÀ-ž]{1}[\sa-zA-ZÀ-ž\-']{1,500}/,
                            }),
                          }}
                        />
                      )}
                    </div>
                    {(!specialquery || !specialquery.endsWith('.json')) && <>
                      <div className={styles.inputContainer}>
                        {formItem[3] && (
                          <Input
                            register
                            name={formItem[3]?.field?.name}
                            placeholder={formItem[3]?.field?.placeholder}
                            type={formItem[3]?.field?.type}
                            errorCheck={errors[formItem[3]?.field?.name]}
                            error={formItem[3]?.field?.error}
                            country
                            setProfiling={setProfiling}
                          />
                        )}
                      </div>
                    </>}

                    <div
                      className={styles.inputContainer}
                      onChange={(e) => {
                        setEmailCheck(e.target.value);
                        setChange(true);
                      }}
                    >
                      {formItem[4] && (
                        <div ref={refMail} className={styles.bigInput}>
                          <Input
                            name={formItem[4]?.field?.name}
                            placeholder={formItem[4]?.field?.placeholder}
                            type={formItem[4]?.field?.type}
                            errorCheck={errors[formItem[4]?.field?.name]}
                            error={formItem[4]?.field?.error}
                            inputProps={{
                              ...register(`${formItem[4]?.field?.name}`, {
                                required: formItem[4]?.field?.error
                                  ? true
                                  : false,
                                pattern:
                                  /^[a-zA-Z0-9_+-]+(\.[a-zA-Z0-9_+-]+)*@[a-zA-Z0-9\-]+(\.[a-zA-Z0-9\-]+)*(\.[a-zA-Z]{2,})$/,
                              }),
                            }}
                          />
                        </div>
                      )}
                    </div>
                    <div
                      className={styles.inputContainer}
                      onChange={(e) => {
                        setPwCheck(e.target.value);
                        setChange(true);
                      }}
                    >
                      {formItem[5] && (
                        <div className={styles.bigInput} ref={refPw}>
                          <Input
                            name={formItem[5]?.field?.name}
                            placeholder={formItem[5]?.field?.placeholder}
                            type={formItem[5]?.field?.type}
                            errorCheck={errors[formItem[5]?.field?.name]}
                            error={formItem[5]?.field?.error}
                            inputProps={{
                              ...register(`${formItem[5]?.field?.name}`, {
                                required: formItem[5]?.field?.error
                                  ? true
                                  : false,
                              }),
                            }}
                          />
                        </div>
                      )}
                    </div>
                    <div>{formItem[13]?.field.placeholder}</div>
                    {(!specialquery || !specialquery.endsWith('.json')) && <>
                      <div className={styles.inputContainer}>
                        {formItem[6] && (
                          <div className={styles.bigInput}>
                            <Input
                              name={formItem[6]?.field?.name}
                              placeholder={formItem[6]?.field?.placeholder}
                              type={formItem[6]?.field?.type}
                              errorCheck={errors[formItem[6]?.field?.name]}
                              error={formItem[6]?.field?.error}
                              control={control}
                              inputProps={{
                                ...register(`${formItem[6]?.field?.name}`, {
                                  required: formItem[6]?.field?.error
                                    ? true
                                    : false,
                                  pattern:
                                    /^(0[1-9]|[12]\d|3[01])\/(0[1-9]|1[0-2])\/([12]\d{3})$/,
                                }),
                              }}
                            />
                          </div>
                        )}
                      </div>
                    </>}
                    {(!specialquery || !specialquery.endsWith('.json')) && <>
                      <div className={styles.inputContainer}>
                        {formItem[7] && (
                          <div className={styles.bigInput}>
                            <Input
                              name={formItem[7]?.field?.name}
                              placeholder={formItem[7]?.field?.placeholder}
                              type={formItem[7]?.field?.type}
                              errorCheck={errors[formItem[7]?.field?.name]}
                              error={formItem[7]?.field?.error}
                              inputProps={{
                                ...register(`${formItem[7]?.field?.name}`, {
                                  required: ( profiling.toUpperCase() === 'IT' || profiling.toUpperCase() === 'FR' ) ? true : false,
                                }),
                              }}
                            />
                          </div>
                        )}
                      </div>
                    </>}

                    {(!specialquery || !specialquery.endsWith('.json')) && <>
                      <div style={{marginTop:'1em'}}>{properties.MESSAGE_REGISTER_PHONE_EXPLANATION}</div>
                      <div className={styles.inputContainer}>
                        {formItem[21] && (
                          <div className={styles.bigInput}>
                            <Input
                              name={formItem[21]?.field?.name}
                              placeholder={formItem[21]?.field?.placeholder}
                              type={formItem[21]?.field?.type}
                              errorCheck={errors[formItem[21]?.field?.name]}
                              error={formItem[21]?.field?.error}
                              inputProps={{
                                ...register(`${formItem[21]?.field?.name}`, {
                                  required: formItem[21]?.field?.error ? true : false,
                                }),
                              }}
                            />
                          </div>
                        )}
                      </div>
                    
                      <div className={styles.inputContainer}>
                        {formItem[22] && (
                          <div className={styles.bigInput}>
                            <Input
                              name={formItem[22]?.field?.name}
                              placeholder={formItem[22]?.field?.placeholder}
                              type={formItem[22]?.field?.type}
                              errorCheck={errors[formItem[22]?.field?.name]}
                              error={formItem[22]?.field?.error}
                              inputProps={{
                                ...register(`${formItem[22]?.field?.name}`, {
                                  required: formItem[22]?.field?.error ? true : false,
                                }),
                              }}
                            />
                          </div>
                        )}
                      </div>
                    </>}
                  </div>

                  {marketingFlag && loyalty ? (
                    <div className={styles.text} dangerouslySetInnerHTML={{
                      __html: properties.FORM_UTENTE_GIA_REGISTRATO
                    }}
                    >
                    </div>
                  ) : marketingFlag ? (
                    <div>
                      <div
                        className={styles.text}
                        dangerouslySetInnerHTML={{
                          __html: profiling.toUpperCase() === 'IT' ? formItem[8]?.field?.values[0] : ( profiling.toUpperCase() === 'CN' ? formItem[8]?.field?.values[2] : formItem[8]?.field?.values[1] ),
                        }}
                      ></div>
                      <div className={styles.checkBoxes}>
                        {formItem[9] && (
                          <div>
                            <Checkbox
                              text={profiling.toUpperCase() === 'IT' ? formItem[9]?.field?.values[0] : ( profiling.toUpperCase() === 'CN' ? formItem[9]?.field?.values[2] : formItem[9]?.field?.values[1] )}
                              name={formItem[9]?.field?.name}
                              required={formItem[9]?.field?.error}
                              errorCheck={errors[formItem[9]?.field?.name]}
                              inputProps={{
                                ...register(`${formItem[9]?.field?.name}`, {
                                  required: true,
                                }),
                              }}
                            />
                          </div>
                        )}
                      </div>
                      <div className={styles.text} dangerouslySetInnerHTML={{
                        __html: properties.FORM_UTENTE_GIA_REGISTRATO
                      }}
                      >
                      </div>
                    </div>
                  ) : (
                    <div>
                      <div
                        className={styles.text}
                        dangerouslySetInnerHTML={{
                          __html: profiling.toUpperCase() === 'IT' ? formItem[8]?.field?.values[0] : ( profiling.toUpperCase() === 'CN' ? formItem[8]?.field?.values[2] : formItem[8]?.field?.values[1] ),
                        }}
                      ></div>

                      <div className={styles.checkBoxes}>
                        {formItem[9] && (
                          <div onChange={(e) => { setLoyalty_check(!loyalty_check) }}>
                            <Checkbox
                              text={profiling.toUpperCase() === 'IT' ? formItem[9]?.field?.values[0] : ( profiling.toUpperCase() === 'CN' ? formItem[9]?.field?.values[2] : formItem[9]?.field?.values[1] )}
                              name={formItem[9]?.field?.name}
                              required={formItem[9]?.field?.error}
                              errorCheck={errors[formItem[9]?.field?.name]}
                              inputProps={{
                                ...register(`${formItem[9]?.field?.name}`, {
                                  required: true,
                                }),
                              }}
                            />
                          </div>
                        )}
                        {formItem[11] && (
                          <div onChange={(e) => { setMarketing_check(!marketing_check) }}>
                            <Checkbox
                              text={profiling.toUpperCase() === 'IT' ? formItem[11]?.field?.values[0] : ( profiling.toUpperCase() === 'CN' ? formItem[11]?.field?.values[2] : formItem[11]?.field?.values[1] ) }
                              marketingFlag
                              name={formItem[11]?.field?.name}
                              required={profiling_check && profiling.toUpperCase() === 'IT' && formItem[11]?.field?.error}
                              errorCheck={errors[formItem[11]?.field?.name]}
                              inputProps={{
                                ...register(`${formItem[11]?.field?.name}`, {
                                  required: profiling_check && profiling.toUpperCase() === 'IT' ? true : false,
                                }),
                              }}
                            />
                          </div>
                        )}
                        {formItem[10] && profiling.toUpperCase() === 'IT' && marketing_check && loyalty_check && (
                          <div onChange={(e) => { setProfiling_check(!profiling_check) }}>
                            <Checkbox
                              text={formItem[10]?.field?.values[0]}
                              name={formItem[10]?.field?.name}
                              required={formItem[10]?.field?.error}
                              inputProps={{
                                ...register(`${formItem[10]?.field?.name}`, {
                                  required: formItem[10]?.field?.error,
                                }),
                              }}
                            />
                          </div>
                        )}
                      </div>
                      {/* SL */}
                      {/* {formItem[12] && (
                        <div
                          className={`${styles.checkBoxes} ${styles.communicationType}`}
                        >
                          <span
                            style={{
                              fontWeight: "bold",
                              color: marketing ? "#a9a9a9" : null,
                            }}
                          >
                            {formItem[12]?.field?.placeholder}
                          </span>
                          <div className={styles.horizontalBoxes}>
                            {formItem[12]?.field?.values[0] &&
                              <Checkbox
                                disabled={marketing ? true : false}
                                text={formItem[12]?.field?.values[0]}
                                required={formItem[12]?.field?.error}
                                errorCheck={errors[formItem[12]?.field?.name]}
                                name="outlets"
                                inputProps={{
                                  ...register("outlets", {
                                    required: formItem[12]?.field?.error,
                                  }),
                                }}
                              />
                            }
                            {formItem[12]?.field?.values[1] &&
                              <Checkbox
                                disabled={marketing ? true : false}
                                text={formItem[12]?.field?.values[1]}
                                required={formItem[12]?.field?.error}
                                errorCheck={errors[formItem[12]?.field?.name]}
                                name="beyond"
                                inputProps={{
                                  ...register("beyond", {
                                    required: formItem[12]?.field?.error,
                                  }),
                                }}
                              />}
                          </div>
                          <div className={styles.required}>
                            {dataContent.layouts.form.note}
                          </div>
                        </div>
                      )} */}
                    </div>
                  )}
                  
                  {formItem[10] && profiling.toUpperCase() !== 'CN' && (
                    <div style={{ marginBottom: "30px" }}
                         dangerouslySetInnerHTML={{
                           __html: profiling.toUpperCase() === 'IT' ? formItem[15]?.field?.values[0] : formItem[15]?.field?.values[1],
                         }}
                    ></div>
                  )}
                  
                  <div style={{ marginBottom: "30px" }}
                       dangerouslySetInnerHTML={{
                         __html: formItem[20]?.field?.values[0],
                       }}
                  ></div>
                  
                  <button
                    className={styles.button}
                    style={{ marginTop: "1rem", width: "292px" }}
                    type="submit"
                  >
                    {dataContent.layouts.form.data.button_title}
                  </button>
                  
                  {formItem[10] && profiling.toUpperCase() === 'CN' && (
                    <div style={{ marginTop: "30px" }}
                         dangerouslySetInnerHTML={{
                           __html: formItem[15]?.field?.values[2],
                         }}
                    ></div>
                  )}
                  
                </form>
              )}
          </div>
        </div>
        <div className="scroll">
          <ScrollDown selector={scrollToRef} scrollTop />
        </div>
      </div>
    </TheMallOutletLayout>
  );
};

Register.getInitialProps = async (context) => {
  let menuItems = null;
  let dataContent = null;
  let properties = null;
  const { slug } = context.query;

  const resmenu = await fetchData("/init", context.query.locale);
  const data = await fetchData(slug, context.query.locale);
  const resproperties = await fetchData(
    null,
    context.query.locale,
    "GET",
    null,
    null,
    null,
    true
  );

  if (resmenu) {
    menuItems = resmenu.menu;
  }

  if (data) {
    dataContent = data;
  }

  if (resproperties) {
    properties = resproperties;
  }

  return {
    menuItems: menuItems,
    dataContent: dataContent,
    properties: properties,
  };
};

export default Register;
